<template>
  <div class="terms-container">
    <div class="gradient-background">
      <div class="content">
        <button class="back-button" @click="goBack">
          <i class="fa fa-chevron-left"></i>
        </button>

        <button class="login-button" @click="goToLogin">
          Iniciar sesión
        </button>

        <img src="/assets/Logo.png" alt="Mistock.co Logo" class="logo">
        <h1 class="title">Términos y Condiciones</h1>
        <div class="terms-content">
          <h2>Términos y Condiciones de mistock.co</h2>
          
          <h2>1. Aceptación de los Términos</h2>
          <p>Al utilizar la plataforma de gestión de producción mistock.co (en adelante, "mistock.co"), usted acepta cumplir con estos términos y condiciones. Si no está de acuerdo con alguna parte de los términos, no podrá utilizar nuestro servicio.</p>

          <h2>2. Descripción del Servicio</h2>
          <p>Nuestra plataforma permite a las fábricas llevar un control integral de su producción, incluyendo la gestión de compra de insumos, control de procesos, asignación de usuarios y seguimiento de producto terminado. El servicio está diseñado para optimizar los procesos de producción y mejorar la eficiencia operativa de las fábricas.</p>

          <h2>3. Uso del Servicio</h2>
          <p>Usted se compromete a utilizar el servicio solo para fines legítimos relacionados con la gestión y control de producción de su fábrica. Esto incluye la gestión de inventarios, procesos de producción, asignación de tareas y seguimiento de productos.</p>

          <h2>4. Responsabilidades del Usuario</h2>
          <p>Como usuario, usted es responsable de:
            <ul>
              <li>Mantener la confidencialidad de su cuenta y contraseña.</li>
              <li>Proporcionar información precisa y actualizada en todos los registros de producción y gestión de inventario.</li>
              <li>Gestionar adecuadamente los permisos y roles de los usuarios asignados.</li>
              <li>Mantener actualizado el registro de insumos y productos terminados.</li>
              <li>Utilizar el servicio de manera ética y legal, respetando las normas de seguridad industrial.</li>
            </ul>
          </p>

          <h2>5. Privacidad y Protección de Datos</h2>
          <p>mistock.co se compromete a proteger su privacidad y los datos de su empresa. La información recopilada, incluyendo datos de producción, inventarios y procesos, se utilizará únicamente para los fines descritos en nuestra Política de Privacidad y para facilitar la gestión de su producción.</p>

          <h2>6. Seguridad de la Información</h2>
          <p>Implementamos medidas de seguridad robustas para proteger la información almacenada en nuestra plataforma, considerando la naturaleza sensible de los datos de producción industrial. Usted es responsable de mantener la seguridad de su cuenta y de notificar inmediatamente cualquier uso no autorizado.</p>

          <h2>7. Propiedad Intelectual</h2>
          <p>Todos los derechos de propiedad intelectual relacionados con la plataforma y su contenido son propiedad de mistock.co. Los usuarios no pueden copiar, modificar, distribuir o utilizar cualquier parte de la plataforma sin nuestro consentimiento expreso.</p>

          <h2>8. Modificaciones del Servicio</h2>
          <p>mistock.co se reserva el derecho de modificar, actualizar o discontinuar el servicio en cualquier momento, con o sin previo aviso. Nos esforzaremos por notificar a los usuarios sobre cambios significativos con antelación razonable.</p>

          <h2>9. Limitación de Responsabilidad</h2>
          <p>mistock.co no será responsable por cualquier daño indirecto, incidental, especial, consecuente o punitivo, incluyendo pérdida de producción o datos, resultante del uso o la imposibilidad de usar nuestro servicio.</p>

          <h2>10. Terminación del Servicio</h2>
          <p>mistock.co se reserva el derecho de suspender o terminar su acceso al servicio si viola estos términos y condiciones o las políticas de uso aceptable de la plataforma.</p>

          <h2>11. Ley Aplicable y Jurisdicción</h2>
          <p>Estos términos se regirán e interpretarán de acuerdo con las leyes de Colombia. Cualquier disputa estará sujeta a la jurisdicción exclusiva de los tribunales de Colombia.</p>

          <h2>12. Cambios en los Términos y Condiciones</h2>
          <p>mistock.co se reserva el derecho de actualizar estos términos y condiciones en cualquier momento. Los cambios entrarán en vigor inmediatamente después de su publicación en la plataforma.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const body = document.getElementsByTagName("body")[0];

export default {
  name: 'Terms',
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    goToLogin() {
      this.$router.push({ name: 'Login' });
    },
  },
  created() {
    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },
}
</script>

<style scoped>
/* Styles remain unchanged as they work well with the new content */
.terms-container {
  min-height: 100vh;
  font-family: Arial, sans-serif;
}

.gradient-background {
  background: linear-gradient(to bottom, #706f6f, #4a4949, #2c2c2c);
  min-height: 100vh;
  padding: 20px;
}

.content {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  position: relative;
}

.back-button {
  position: absolute;
  top: 20px;
  left: 20px;
  background: none;
  border: none;
  color: #f9b000;
  font-size: 24px;
  cursor: pointer;
}

.logo {
  width: 100px;
  height: 100px;
  object-fit: contain;
  margin: 0 auto 30px;
  display: block;
}

.title {
  font-size: 28px;
  color: #f9b000;
  font-weight: bold;
  text-align: center;
  margin-bottom: 30px;
}

.terms-content {
  color: #fff;
  margin-bottom: 30px;
  max-height: 60vh;
  overflow-y: auto;
  padding-right: 15px;
}

.terms-content h2 {
  color: #f9b000;
  font-size: 20px;
  margin-top: 20px;
  margin-bottom: 10px;
}

.terms-content p {
  margin-bottom: 15px;
  line-height: 1.6;
}

.terms-content::-webkit-scrollbar {
  width: 8px;
}

.terms-content::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.terms-content::-webkit-scrollbar-thumb {
  background-color: #f9b000;
  border-radius: 4px;
}

.login-button {
  position: absolute;
  top: 30px;
  right: 20px;
  background: none;
  border: none;
  color: #f9b000;
  font-size: 16px;
  cursor: pointer;
}
</style>